import { render, staticRenderFns } from "./MyScoreData.vue?vue&type=template&id=374513ff&scoped=true"
import script from "./MyScoreData.vue?vue&type=script&lang=js"
export * from "./MyScoreData.vue?vue&type=script&lang=js"
import style0 from "./MyScoreData.vue?vue&type=style&index=0&id=374513ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374513ff",
  null
  
)

export default component.exports